import { t } from '@ankr.com/common';

import { ChainTypeTab } from 'modules/common/components/ChainTypeTab';
import { Tab } from 'uiKit/TabsManager';
import { Technology } from 'modules/chains/constants';

const getTabTitlesMap = (key: Technology) => {
  switch (key) {
    case Technology.CURL:
      return t('chain-item.get-started.connection-snippet.technologies.curl');

    case Technology.GO:
      return t('chain-item.get-started.connection-snippet.technologies.go');

    case Technology.PYTHON:
      return t('chain-item.get-started.connection-snippet.technologies.python');

    case Technology.WEB3_JS:
      return t(
        'chain-item.get-started.connection-snippet.technologies.web3-js',
      );

    default:
      return '';
  }
};

const titleRenderFn = (isSelected: boolean, _: boolean, id: Technology) => (
  <ChainTypeTab content={getTabTitlesMap(id)} isSelected={isSelected} />
);

export const tabs: Tab<Technology>[] = [
  {
    id: Technology.CURL,
    title: titleRenderFn,
  },
  {
    id: Technology.GO,
    title: titleRenderFn,
  },
  {
    id: Technology.WEB3_JS,
    title: titleRenderFn,
  },
  {
    id: Technology.PYTHON,
    title: titleRenderFn,
  },
];

export const getTitle = () =>
  t('chain-item.get-started.connection-snippet.title');
